import { FunctionComponent } from 'react'

import { isHTML } from '@/utils/thmlUtls'

import { TPageTitleProps } from './types'

export const PageTitle: FunctionComponent<TPageTitleProps> = ({
  title,
  children,
  isUppercase,
  ...props
}: TPageTitleProps) => {
  const htmlRegex = isHTML(title)

  let className = 'page-title'
  if (isUppercase) {
    className += ' uppercase'
  }
  if (htmlRegex) {
    return (
      <div className={className} dangerouslySetInnerHTML={{ __html: title }} {...props}>
        {children}
      </div>
    )
  }

  return (
    <div className={className} {...props}>
      {title}
    </div>
  )
}

export type { TPageTitleProps }
